import { LayoutBase } from './LayoutBase';

export default class extends LayoutBase {
  getSize(): {
    width: number;
    height: number;
    offsetX?: number;
    offsetY?: number;
  } {
    const node = this.dataItem as IDataItemLineProgressBar;
    const ref = this.runtime.getDataItem<IImage>(node.ref);
    const refImg = ref?.imgEl;
    const { width = 0, height = 0 } = refImg ?? {};

    // 指示器
    const { imgEl: indicatorImageEl } =
      this.runtime.getDataItem<IImage>(node.indicatorImage) ?? {};
    const { width: widthIndicator = 0, height: heightIndicator = 0 } =
      indicatorImageEl ?? {};

    return {
      width: width + widthIndicator,
      height: Math.max(height, heightIndicator),
      offsetX: widthIndicator / 2,
      offsetY: heightIndicator > height ? (heightIndicator - height) / 2 : 0
    };
  }

  private getFinishPosition() {
    const { dataItem } = this;
    const node = dataItem as IDataItemLineProgressBar;
    const { startX, startY, source, endX, endY } = node;
    // 进度比例
    const data = this.getDataSourceValue(source) as number;
    const { valueStart, valueRange } = this.getValueStartRange();
    let ratio = (data - valueStart) / valueRange;
    if (valueRange > 0) {
      if (data < valueStart) {
        ratio = 0;
      } else if (data > valueRange + valueStart) {
        ratio = 1;
      }
    } else if (valueRange < 0) {
      if (data > valueStart) {
        ratio = 0;
      } else if (data < valueRange + valueStart) {
        ratio = 1;
      }
    } else if (valueRange == 0) {
      // 当valueStart == 0时
      if (data < valueStart) {
        ratio = 0;
      } else {
        ratio = 1;
      }
    }

    const spaceX = endX - startX;
    const spaceY = endY - startY;

    const finishX = spaceX ? startX + spaceX * ratio : endX;
    const finishY = spaceY ? startY + spaceY * ratio : endY;
    return { finishX, finishY };
  }

  draw(): void {
    const { ctx, runtime, dataItem, _alpha = 1 } = this;
    ctx.save();

    const node = dataItem as IDataItemLineProgressBar;
    const {
      ref,
      bg,
      indicatorImage,
      startX,
      startY,
      endingStyle = 'normal',
      barWidth = 0,
      indicatorOffsetX = 0,
      indicatorOffsetY = 0
    } = node;

    const { width, height, offsetX = 0, offsetY = 0 } = this.getSize();
    if (!width || !height) return;

    const { finishX, finishY } = this.getFinishPosition();
    // 背景
    const { imgEl: bgEl, src: bgSrc } = runtime.getDataItem<IImage>(bg) ?? {};
    // 进度条
    const { imgEl: progressEl, src: progressSrc } =
      runtime.getDataItem<IImage>(ref) ?? {};
    // 指示器
    const { imgEl: indicatorImageEl, src: indicatorImageSrc } =
      runtime.getDataItem<IImage>(indicatorImage) ?? {};

    // 透明度
    ctx.globalAlpha = _alpha;

    const { canvas: offscreenCanvas } = this.getOffscreen(
      {
        width,
        height,
        init: (_, ctx) => {
          // 背景
          if (bgEl) {
            this.drawRecolorImage(ctx, bgEl, {
              x: offsetX,
              y: offsetY
            });
          }
          if (progressEl) {
            const { width, height } = progressEl;
            const { canvas: offScreenCanvas } = this.getOffscreen(
              {
                width,
                height,
                init: (_, ctx) => {
                  this.drawRecolorImage(ctx, progressEl, {
                    x: 0,
                    y: 0
                  });

                  if (endingStyle === 'round') {
                    ctx.lineCap = 'round';
                  }
                  ctx.globalCompositeOperation = 'destination-in';
                  ctx.lineWidth = barWidth;
                  ctx.beginPath();
                  ctx.moveTo(startX, startY);
                  ctx.lineTo(finishX, finishY);
                  ctx.stroke();
                  ctx.closePath();
                },
                dirtyParmas: {
                  key: Math.random()
                }
              },
              'DataItemLineProgressBar2'
            );
            ctx.drawImage(offScreenCanvas, offsetX, offsetY);

            if (indicatorImageEl) {
              ctx.globalCompositeOperation = 'source-over';
              const { width, height } = indicatorImageEl;
              const _offsetX = offsetX + indicatorOffsetX;
              const _offsetY = offsetY + indicatorOffsetY;
              const ix = finishX - width / 2 + _offsetX;
              const iy = finishY - height / 2 + _offsetY;
              this.drawRecolorImage(ctx, indicatorImageEl, {
                x: ix,
                y: iy
              });
            }
          }
        },
        dirtyParmas: {
          src: progressSrc ?? '',
          bgSrc: bgSrc ?? '',
          indicatorImageSrc: indicatorImageSrc ?? '',
          startX,
          startY,
          finishX,
          finishY,
          barWidth,
          endingStyle
        }
      },
      'DataItemLineProgressBar1'
    );

    // ctx.drawImage(offscreenCanvas, x - offsetX, y - offsetY);
    this.drawAniFrame(offscreenCanvas, {
      selfOffset: {
        offsetX: -offsetX,
        offsetY: -offsetY
      }
    });

    this.setRuntimeData({
      width,
      height,
      rotation: 0
    });
    ctx.restore();
  }
}
